export default __webpack_public_path__ + "static/media/Vault.b9adef91.svg";